import React from 'react';

import {QrCodeGenerator} from 'src/design/organisms/QrCodeGenerator';
import {PathUtility} from 'src/shared/constants/PathBuilder';

const BulletinQrCodeTab: React.FC = () => {
  const url = `${
    window.location.hostname
  }${PathUtility.BulletinDashboardParameterless()}`;
  return <QrCodeGenerator value={url} />;
};

export default BulletinQrCodeTab;
